var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasData
    ? _c(
        "div",
        {
          staticClass: "table-responsive",
          style: `direction:${_vm.layoutDirection}`,
        },
        [
          _c(
            "table",
            { staticClass: "table table-hover" },
            [
              _c("thead", { staticClass: "thead-light" }, [
                _c(
                  "tr",
                  _vm._l(_vm.visibleColumns, function (column) {
                    return _c(
                      "th",
                      { key: column.key, attrs: { scope: "col" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.Lang.get(column.label)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "transition-group",
                { attrs: { name: "table-rows", tag: "tbody", mode: "out-in" } },
                [
                  !_vm.hasData
                    ? _c("tr", { key: 0, staticClass: "table-secondary" }, [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: _vm.visibleColumns.length },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.Lang.get("messages.no_results")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tableType === "hierarchical"
                    ? [
                        _vm._l(_vm.data, function (yearLevel, yearsIndex) {
                          return [
                            _vm._l(
                              yearLevel.classes,
                              function (classItem, classesIndex) {
                                return _vm._l(
                                  classItem.students,
                                  function (item, index) {
                                    return _c(
                                      "tr",
                                      {
                                        key: `student-${yearsIndex}-${classesIndex}-${index}`,
                                      },
                                      _vm._l(
                                        _vm.visibleColumns,
                                        function (column) {
                                          return _c(
                                            "td",
                                            {
                                              key: column.key,
                                              class: column.cellClass || "",
                                            },
                                            [
                                              column.key === "#"
                                                ? [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(index + 1) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getNestedValue(
                                                            item,
                                                            column.path,
                                                            column.fallback
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  }
                                )
                              }
                            ),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.totalCount > 0 && _vm.showSummaries
                          ? _c("tr", { key: "total-summary" }, [
                              _c("td", { attrs: { colspan: "2" } }),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.Lang.get("messages.school_count"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v(_vm._s(_vm.totalCount))]),
                              _vm._v(" "),
                              _c("td", {
                                attrs: {
                                  colspan: _vm.visibleColumns.length - 4,
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._l(_vm.data, function (item, index) {
                        return _c(
                          "tr",
                          { key: `item-${index}` },
                          _vm._l(_vm.visibleColumns, function (column) {
                            return _c(
                              "td",
                              {
                                key: column.key,
                                class: column.cellClass || "",
                              },
                              [
                                column.key === "#"
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(index + 1) +
                                          "\n            "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getNestedValue(
                                              item,
                                              column.path,
                                              column.fallback
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ],
                              ],
                              2
                            )
                          }),
                          0
                        )
                      }),
                ],
                2
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }